import axios from 'axios';

export const getServiceCallTypeOptions = async () => {
  const response = await axios.get('service-call-type/options');
  return response.data;
};

export const storeServiceCallType = async (name) => {
  const response = await axios.post('service-call-type/store', { name });
  return response.data;
};

export const deleteServiceCallType = async (id) => {
  const response = await axios.delete(`service-call-type/${id}`);
  return response.data;
};
